<template>
  <section class="personal-center-panel">
    <h2>分会绑定</h2>
    <p>已绑定 {{ front.boundBranchCount }} 个分会</p>
    <p>{{ front.boundAssociationNames }}</p>
    <button type="button" class="primary-action compact" @click="front.goServicesTab('branches')">管理分会绑定</button>
  </section>
</template>

<script>
export default {
  name: 'PersonalBranchesPanel',
  inject: ['front']
}
</script>
